import { useAtomValue } from "jotai";
import type { MouseEvent } from "react";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { WidgetOptions } from "@/shared/types/widgetOptions";
import { ARROW_END_ICONS } from "../../constants/arrowEndIcons";
import type { ActiveSubMenuState, MenuOptionResult, SetActiveSubMenu } from "../../types";

interface UseArrowEndButtonProps {
    name: WidgetOptions;
    activeSubMenu: ActiveSubMenuState | null;
    setActiveSubMenu: SetActiveSubMenu;
}

export function useArrowEndButton({
    name,
    activeSubMenu,
    setActiveSubMenu,
}: UseArrowEndButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom(name));

    const uniqueValues = [...new Set(options.map((option) => option.value))];

    const Icon =
        uniqueValues.length === 1
            ? ARROW_END_ICONS[uniqueValues[0] as string]
            : ARROW_END_ICONS.none;

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;

        setActiveSubMenu((prev) => (prev?.name === name ? null : { name, anchor: button }));
    };

    const content = <Icon />;

    const isActive = activeSubMenu?.name === name;

    return {
        content,
        handleClick,
        isActive,
    };
}
